import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

const TicketList = () => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  const [status, setStatus] = useState("OPEN");
  const [ticketId, setTicketId] = useState("");
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [remarks, setRemarks] = useState("");

  // ✅ Fetch tickets
  const fetchTickets = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/user/get_all_tickets",
        {
          params: {
            status: status || undefined,
            ticket_id: ticketId || undefined,
            module_id: "TICKET",
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTickets(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const updateTicketStatus = async () => {
  try {
    await axios.patch(
      `https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/user/update_ticket/${selectedTicket._id}`,
      {
        status: newStatus,
        Support_Team_remarks: remarks,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "module-id": "TICKET",
        },
      }
    );

    alert("Ticket updated successfully");

    setSelectedTicket(null);
    fetchTickets(); // refresh list
  } catch (err) {
    console.error(err);
    alert("Error updating ticket");
  }
};

  // ✅ Load all tickets on page load
  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <div className="min-h-screen md:ml-64 mt-28 md:mt-28 bg-gray-100 p-4 sm:p-6">

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-lg sm:text-2xl font-semibold text-gray-800">
          Ticket Management
        </h1>
        <p className="text-xs sm:text-sm text-gray-500">
          Manage and track all support tickets
        </p>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl shadow-sm mb-6 flex flex-col md:flex-row gap-4 md:items-end">

        {/* Ticket ID */}
        <div className="flex-1">
          <label className="text-xs sm:text-sm text-gray-600">
            Ticket ID
          </label>
          <input
            type="text"
            value={ticketId}
            onChange={(e) => setTicketId(e.target.value)}
            placeholder="Enter ticket ID"
            className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Status */}
        <div className="w-full md:w-48">
          <label className="text-xs sm:text-sm text-gray-600">
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All</option>
            <option value="OPEN">Open</option>
            <option value="CLOSED">Closed</option>
          </select>
        </div>

        {/* Button */}
        <button
          onClick={fetchTickets}
          className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 text-sm w-full md:w-auto"
        >
          Search
        </button>
      </div>

      {/* Ticket List */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">

        {/* Desktop Table */}
        <div className="hidden md:grid grid-cols-5 bg-gray-50 text-gray-600 text-sm font-medium px-4 py-3">
          <div>Ticket ID</div>
          <div>Subject</div>
          <div>Status</div>
          <div>Category</div>
          <div className="text-center">Action</div>
        </div>

        {/* Loading */}
        {loading && (
          <div className="text-center py-6 text-gray-500">
            Loading tickets...
          </div>
        )}

        {/* Empty */}
        {!loading && tickets.length === 0 && (
          <div className="text-center py-10 text-gray-400">
            No tickets found
          </div>
        )}

        {/* Data */}
        {!loading &&
          tickets.map((item) => (
            <div
              key={item._id}
              className="border-t px-4 py-3 text-sm"
            >
              {/* Desktop */}
              <div className="hidden md:grid grid-cols-5 items-center">
                <div>{item.ticket_id}</div>
                <div>{item.subject}</div>
                <div
                  className={`font-medium ${
                    item.status === "OPEN"
                      ? "text-green-600"
                      : "text-red-500"
                  }`}
                >
                  {item.status}
                </div>
                <div>{item.category}</div>
                <button
  onClick={() => setSelectedTicket(item)}
  className="text-blue-600 hover:underline"
>
  View
</button>
              </div>

              {selectedTicket && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    
    <div className="bg-white w-[90%] max-w-lg rounded-xl p-6">
      
      <h2 className="text-lg font-semibold mb-4">
        Ticket Details
      </h2>

      <div className="space-y-2 text-sm">
  <p><b>ID:</b> {selectedTicket.ticket_id}</p>
  <p><b>Subject:</b> {selectedTicket.subject}</p>
  <p><b>Status:</b> {selectedTicket.status}</p>
  <p><b>Category:</b> {selectedTicket.category}</p>

 <div>
  <b>Description:</b>
  <p className="mt-1 text-gray-600">
    {selectedTicket.description}
  </p>
</div>

{/* ✅ ADD HERE (only once) */}
<div className="mt-4">
  <label className="text-sm font-medium">Update Status</label>
  <select
    value={newStatus}
    onChange={(e) => setNewStatus(e.target.value)}
    className="w-full border px-3 py-2 mt-1 rounded-lg"
  >
    <option value="">Select</option>
    <option value="OPEN">Open</option>
    <option value="PENDING">Pending</option>
    <option value="CLOSED">Closed</option>
  </select>
</div>

<div className="mt-3">
  <label className="text-sm font-medium">Remarks</label>
  <textarea
    value={remarks}
    onChange={(e) => setRemarks(e.target.value)}
    className="w-full border px-3 py-2 mt-1 rounded-lg"
    placeholder="Enter remarks"
  />
</div>

  {/* ✅ ADD THIS */}
  <div className="mt-3">
    <b>Contact Details:</b>
    <p>Name: {selectedTicket?.contacts?.name}</p>
    <p>Email: {selectedTicket?.contacts?.email}</p>
    <p>Phone: {selectedTicket?.contacts?.phone_number}</p>
  </div>
</div>

      <div className="flex gap-2">
  <button
    onClick={updateTicketStatus}
    className="bg-green-600 text-white px-4 py-2 rounded-lg"
  >
    Update
  </button>

  <button
    onClick={() => setSelectedTicket(null)}
    className="bg-gray-400 text-white px-4 py-2 rounded-lg"
  >
    Close
  </button>
</div>

    </div>
  </div>
)}

              {/* Mobile Card */}
              <div className="md:hidden space-y-2">
                <div className="font-medium text-gray-800">
                  {item.subject}
                </div>

                <div className="text-xs text-gray-500">
                  {item.ticket_id}
                </div>

                <div className="flex justify-between items-center">
                  <span
                    className={`text-xs font-medium px-2 py-1 rounded ${
                      item.status === "OPEN"
                        ? "bg-green-100 text-green-600"
                        : "bg-red-100 text-red-500"
                    }`}
                  >
                    {item.status}
                  </span>

                  <div className="flex justify-start md:justify-center">
  <button
    onClick={() => setSelectedTicket(item)}
    className="text-blue-600 hover:underline"
  >
    View
  </button>
</div>
                </div>
              </div>
            </div>
          ))}

      </div>
    </div>
  );
};

export default TicketList;